// extracted by mini-css-extract-plugin
export var categoryCopy = "seoCategoryListing-module--categoryCopy--84ef8";
export var categoryIcon = "seoCategoryListing-module--categoryIcon--812f8";
export var categoryItem = "seoCategoryListing-module--categoryItem--44a1e";
export var featuredResource = "seoCategoryListing-module--featuredResource--9fbaf";
export var featuredResources = "seoCategoryListing-module--featuredResources--a4ea1";
export var itemIndex0 = "seoCategoryListing-module--itemIndex0--07960";
export var itemIndex1 = "seoCategoryListing-module--itemIndex1--0dca9";
export var itemIndex2 = "seoCategoryListing-module--itemIndex2--0578f";